import { useBrand } from "../lib/brand";
import { useTitle } from "../lib/useTitle";

export function LegalNotice() {
  useTitle("Mentions légales");
  return (
    <div className="page">
      <article className="prose">
        <h1>Mentions légales</h1>
        <h2>Éditeur</h2>
        <p>
          Contact-Me SAS au capital de 1380 €, SIREN{" "}
          884 119 215, siège : 11 rue de Lourmel, 75015 Paris.
          <br />
          Directeur de la publication : Joseph de Soissan. Contact : contact@contact-me.io.
        </p>
        <h2>Hébergement</h2>
        <p>
          OVH SAS, 2 rue Kellerman, Roubaix.
        </p>
        <h2>Données affichées</h2>
        <p>
          {useBrand().productName} est un service indépendant. Il n'est ni édité ni approuvé par l'administration. Les
          informations proviennent de sources publiques :
        </p>
        <ul>
          <li>
            BODACC, publié par la Direction de l'information légale et administrative (DILA), diffusé en open data
            sous licence ODbL ;
          </li>
          <li>
            Base Sirene de l'INSEE et Registre national des entreprises, via l'API Recherche d'entreprises de la
            DINUM.
          </li>
        </ul>
        <p>
          Ces informations sont reprises telles que publiées, sans garantie d'exhaustivité ni de délai. Seules les
          publications officielles font foi.
        </p>
      </article>
    </div>
  );
}

export function Privacy() {
  useTitle("Confidentialité");
  return (
    <div className="page">
      <article className="prose">
        <h1>Confidentialité</h1>
        <p>
          Le responsable du traitement est Contact-Me SAS. Pour toute question ou pour
          exercer vos droits : contact@contact-me.io.
        </p>
        <h2>Ce que nous conservons</h2>
        <ul>
          <li>votre adresse e-mail ;</li>
          <li>les entreprises que vous suivez et les noms que vous leur donnez ;</li>
          <li>la date d'envoi de chaque alerte, pour ne jamais l'envoyer deux fois.</li>
        </ul>
        <p>Rien d'autre : pas de mot de passe, pas de mesure d'audience, pas de publicité.</p>
        <h2>Pourquoi</h2>
        <p>
          Uniquement pour vous envoyer les alertes demandées (exécution du service que vous avez demandé). Vos
          données ne sont ni vendues ni partagées, sauf avec notre prestataire d'envoi d'e-mails{" "}
          Brevo, qui les traite pour notre compte.
        </p>
        <h2>Combien de temps</h2>
        <p>
          Tant que votre compte existe. La suppression depuis la page « Mon compte » efface immédiatement votre
          adresse et vos suivis. Les comptes jamais confirmés sont supprimés après 1 mois.
        </p>
        <h2>Cookies</h2>
        <p>
          Un seul cookie, strictement nécessaire : il vous garde connecté pendant 30 jours. Il ne sert à aucun
          suivi et ne nécessite donc pas de consentement.
        </p>
        <h2>Vos droits</h2>
        <p>
          Vous pouvez accéder à vos données, les rectifier, les supprimer ou vous opposer à leur traitement en
          nous écrivant. Vous pouvez aussi introduire une réclamation auprès de la CNIL (cnil.fr).
        </p>
      </article>
    </div>
  );
}
